import { IServicePackagePeriod } from '../../../repositories/billing-tariffs/entities/PublishTerms/ServicePackagePeriod';

export function getPackageId(servicePackage: IServicePackagePeriod): string {
  const {
    tariffIdentificator: { tariffId, tariffGridType },
  } = servicePackage;

  return `${tariffId}${tariffGridType}`;
}
